module.exports = __webpack_public_path__ + "static/img/award2_a.54f46bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/index/award2_a.png
// module id = ig9Y
// module chunks = 7